
import React, { PureComponent } from "react";
import styles from "./TotalBalance.scss";
import { t } from "helpers/localization";
import { Currency, Spinner } from "@wg/wows-react-uikit";

import { Balance } from "../../../Reducers/ReducerTreasury";

export type TotalBalance_Props = {
  currencyList: Balance;
  isUpdating: boolean;
};

class TotalBalance extends PureComponent<TotalBalance_Props, any> {

  render() {

    if (this.props.isUpdating) {
      return <div className={styles.preloader}>
                    <Spinner />
                </div>;
    }

    return <div className={styles.wrapper}>
                {this.props.currencyList.length > 0 ? this.props.currencyList.sort((a, b) => Currency.order[b.type] - Currency.order[a.type]).map((item, index) => {
        return <div key={`TotalCurrnecy${index}`}>
                            <Currency type={item.type} amount={item.amount} isBold t={t} />
                        </div>;
      }) : <div className={styles.preloader} />}
            </div>;
  }
}

export default TotalBalance;